// extracted by mini-css-extract-plugin
export default {"ScrollableWrapper":"ScrollableWrapper_ScrollableWrapper__YNuxm"};